import wx from 'weixin-js-sdk';
import axios from 'axios';
//import Vue from "vue";
//const _axios = Vue.prototype.$axios;
const wechat = {
    /**
     * 初始化微信 JSSDK 配置
     * @param {String} url 当前页面的完整 URL
     * @returns {Promise<void>}
     */
    initConfig(sigUrl) {
        return axios
            .get('https://api.ayerdudu.com/v1/3rd/wechat.get_jsinfo', { params: { sigUrl } })
            .then((response) => {
                const { appid, timestamp, noncestr, signature } = response.data.data;
                wx.config({
                    debug: false, // 开启调试模式
                    appId:appid, // 公众号的唯一标识
                    timestamp:timestamp, // 时间戳
                    nonceStr:noncestr, // 随机字符串
                    signature:signature, // 签名
                    jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'], // 需要用到的 API
                });
            })
            .catch((error) => {
                console.error('微信签名初始化失败:', error);
            });
    },

    /**
     * 设置分享内容
     * @param {Object} options 分享内容配置
     */
    setShareOptions(options) {
        wx.ready(() => {
            const shareData = {
                title: options.title || '默认标题',
                desc: options.desc || '默认描述',
                link: options.link || window.location.href,
                imgUrl: options.imgUrl || '',
            };

            // 分享给朋友
            wx.updateAppMessageShareData(shareData, (res) => {
                console.log('分享给朋友设置成功:', res);
            });

            // 分享到朋友圈
            wx.updateTimelineShareData(shareData, (res) => {
                console.log('分享到朋友圈设置成功:', res);
            });
        });

        wx.error((err) => {
            console.error('微信 JSSDK 错误:', err,wx);
        });
    },
};

export default wechat;